<form class="filter-container" (ngSubmit)="submitForm($event)" [formGroup]="rangeForm">
    <div class="filter-container-group">
        <label class="filter-container-title">{{ title }} {{ labelWithoutTitle }}</label>
        <div class="range-container">
            <p-slider
                [value]="rangeValuesTotal"
                [ngModel]="rangeValuesTotal"
                [ngModelOptions]="{standalone: true}"
                [range]="true"
                [min]="valueMin"
                [max]="valueMax"
                [step]="stepInput"
                (onChange)="onSliderChange($event)"
            >
            </p-slider>
            <div class="range-inputs">
                <p-inputNumber
                    formControlName="valueFrom"
                    [placeholder]="rangeForm.get('valueFrom').value === null ? ('From' | localize) : ''"
                    (onInput)="updateValueFrom($event.value)"
                    mode="decimal"
                    [suffix]="suffix"
                    name="minPrice"
                    class="filter-input"
                    [min]="valueMin"
                    [max]="valueMax"
                    [showClear]="true"
                    (onClear)="clearValueFrom()"
                    [step]="stepInput"
                />
                <span class="rangeDash">-</span>
                <p-inputNumber
                    formControlName="valueTo"
                    [placeholder]="rangeForm.get('valueTo').value === null ? ('To' | localize) : ''"
                    (onInput)="updateValueTo($event.value)"
                    mode="decimal"
                    [suffix]="suffix"
                    name="maxPrice"
                    class="filter-input"
                    [min]="valueFrom"
                    [max]="valueMax"
                    [showClear]="true"
                    (onClear)="clearValueTo()"
                    [step]="stepInput"
                />
            </div>
        </div>
    </div>
</form>
